import { useState } from 'react';
import { HiExternalLink } from 'react-icons/hi';
import HeroSection from '../components/ui/HeroSection';
import ChalkboardBackground from '../components/ui/ChalkboardBackground';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import portfolio from '../data/portfolio.json';
import siteContent from '../data/siteContent.json';
import homeBg from '../assets/images/bb-background.png';
import portfolioBg from '../assets/images/portfolio-banner.png';
import Seo from '../components/Seo';

export default function Portfolio() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <Seo
        title="Bridal Hair & Makeup Portfolio"
        description="Browse real Kansas City brides styled by Blush & Bobby. See our bridal hair and makeup portfolio for wedding day beauty inspiration."
        path="/portfolio"
      />
      {/* Hero */}
      <HeroSection title="Portfolio" backgroundImage={portfolioBg} overlayColor="bg-dusty-rose/25" />

      {/* Gallery */}
      <ChalkboardBackground className="py-16 md:py-24">
        <div className="container-custom">
          {/* Image Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {portfolio.images.map((image) => (
              <Card
                key={image.id}
                onClick={() => setSelectedImage(image)}
                className="aspect-square cursor-pointer"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover"
                />
              </Card>
            ))}
          </div>

          {/* Empty State */}
          {portfolio.images.length === 0 && (
            <div className="text-center py-12">
              <p className="text-dusty-rose/50">No images yet.</p>
            </div>
          )}
        </div>
      </ChalkboardBackground>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-charcoal-dark/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="max-w-4xl w-full">
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="w-full h-auto rounded-lg shadow-2xl border border-dusty-rose/20"
            />
            <p className="text-center text-dusty-rose/70 mt-4 text-sm font-medium uppercase tracking-widest">Click anywhere to close</p>
          </div>
        </div>
      )}

      {/* Final CTA */}
      <ChalkboardBackground 
        as="section" 
        backgroundImage={homeBg}
        backgroundOpacity={0.5}
        className="py-12 md:py-16 lg:py-20"
      >
        <div className="container-custom">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-headline font-semibold mb-6 text-chalk uppercase tracking-wider">
              Let's Create Your Dream Look
            </h2>
            <Button
              href={siteContent.social.linktree}
              target="_blank"
              rel="noopener noreferrer"
              variant="outline"
              size="lg"
              className="!text-xs"
            >
              Check Availability
              <HiExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </ChalkboardBackground>
    </>
  );
}
